var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_user-agent.js